import { Tabs, Page, Card, Box } from "@shopify/polaris";
import { useState, useCallback } from "react";
import ReviewsComponent from "../../Components/ReviewsComponent.js";

const Reviews = () => {
  const [selected, setSelected] = useState(0);

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );

  const tabs = [
    {
      id: "instructors-reviews",
      content: "Instructors Reviews",
    },
    {
      id: "sessions-reviews",
      content: "Classes Reviews",
    },
  ];

  return (
    <Page title="Reviews">
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} fitted>
          {selected === 0 ? (
            <ReviewsComponent api="instructor-reviews" type="instructors" />
          ) : (
            <ReviewsComponent api="class-reviews" type="sessions" />
          )}
        </Tabs>
      </Card>
    </Page>
  );
};

export default Reviews;
